import service from '../utils/request';

// 获取资金冻结记录分页列表
export const getAccountFreezeRecordList = (params) => {
  return service.get('/account-freeze-records/list', { params });
};

// 分页查询陪逛员余额冻结记录
export const getProviderBalanceFreezeRecordPage = (data) => {
  return service.post('/provider-balance-freeze/page', data);
};

// 分页查询商家余额冻结记录（POST）
export const getMerchantBalanceFreezeRecordPage = (params) => {
  return service.post('/merchant-balance-freeze-record/page',  params );
}; 

// 分页查询用户余额冻结记录（GET）
export const getUserBalanceFreezeRecordPage = (params) => {
  return service.get('/user-balance-freeze-record/page', { params });
};